import { useEffect } from 'react';

import { CURRENT_LOCALE, LOCALES } from 'src/constants';
import { createFontsTags } from 'src/utils';

const useLocale = () => {
  useEffect(() => {
    const isHebrewVersion = CURRENT_LOCALE === 'he';
    const direction = isHebrewVersion ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', direction);
    document.documentElement.setAttribute('lang', CURRENT_LOCALE);
    if (isHebrewVersion) {
      document.title = LOCALES.AFTERCARE_SERVICES;
    }

    const removeFontsTags = createFontsTags(isHebrewVersion);
    return removeFontsTags;
  }, []);
};

export default useLocale;
